import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd-mobile';

const confirmAlert = Modal.alert;

@inject(
  'templateStore',
  'CmsLanguageStore',
  'webSettingStore',
  'CmsMenuStore'
)
@observer
class HomeContentThemeTwo extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
  }

  menuSoonClick = () => {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    confirmAlert('',
      <div
        style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          color: activeTemplate.templateSetting.text.color,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
          textAlign: 'center'
        }}
      >
        <span>Available Soon</span>
      </div>,
      [
        {
          text: webSetting.okText
        }
      ]);
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    const { data: activeMenus } = this.props.CmsMenuStore;
    const lang = window.localStorage.getItem('lang') || 'en';
    const { activeLanguages } = this.props.CmsLanguageStore;

    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {
                webSetting
                  ?
                  <Col
                    span={24}
                    className='stm-height-50-vh'
                    style={{
                      background: activeTemplate.templateSetting.header.backgroundColor
                    }}
                  >
                    <Row>
                      <Col span={24} className='stm-padding-top-32 stm-padding-left-16'>
                        <span
                          style={{
                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                            color: activeTemplate.templateSetting.header.color,
                            fontSize: activeTemplate.templateSetting.header.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.header.fontSize + 6}px`
                          }}
                        >Explore our legendary services...</span>
                      </Col>
                      <Col span={24} className='stm-padding-top-8'>
                        <div className='stm-home-theme-two-grid-container'>
                          <div className='stm-home-theme-two-menu-grid'>

                            {/* Active Menus */}
                            <>
                              {
                                activeMenus.map(menu => {
                                  return (
                                    menu.menuType === 'IN_ROOM_DINING' ||
                                      menu.menuType === 'SHOPPING' ||
                                      menu.menuType === 'LAUNDRY' ||
                                      menu.menuType === 'SPA' ||
                                      menu.menuType === 'BOOKING_FACILITY'
                                      ?
                                      <div className='stm-home-theme-two-menu-item' onClick={() => this.menuClick(menu.taskID, menu.menuType, menu.isSoon, menu.redirectUrl)}>
                                        <div className='stm-border-radius-16'>
                                          <img
                                            src={menu.bannerUrl}
                                            alt='Logo'
                                            className='stm-home-theme-two-img-menu-item'
                                          />
                                        </div>
                                        <div className='stm-home-theme-two-menu-item-name'>
                                          <span
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                              color: activeTemplate.templateSetting.header.color,
                                              fontSize: activeTemplate.templateSetting.label.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                          >{menu.taskLanguages.find(fi => fi.langID === languageId).taskLangName}</span>
                                        </div>
                                      </div>
                                      :
                                      null
                                  )
                                })
                              }
                            </>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default HomeContentThemeTwo;